import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/components/ui/table";
import { Check } from "lucide-react";
import { DeployNotification } from "../../types/deploy-notification.types";

function formatDate(value: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
}

function formatDateOnly(value: string | null): string {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleDateString();
}

interface DeployNotificationsTableProps {
  notifications: DeployNotification[];
  onRowClick?: (notification: DeployNotification) => void;
}

const cellPadding = "py-4 px-4";

const DeployNotificationsTable: React.FC<DeployNotificationsTableProps> = ({
  notifications,
  onRowClick,
}) => {
  return (
    <div className="w-full bg-white rounded-lg border border-gray-200 overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className={cellPadding}>
              Status
            </TableHead>
            <TableHead className={cellPadding}>
              Start date
            </TableHead>
            <TableHead className={cellPadding}>
              End date
            </TableHead>
            <TableHead className={cellPadding}>
              Audience
            </TableHead>
            <TableHead className={cellPadding}>
              Created
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {!notifications.length ? (
            <TableRow>
              <TableCell
                colSpan={5}
                className={`py-12 text-center text-gray-500 ${cellPadding}`}
              >
                No requests found.
              </TableCell>
            </TableRow>
          ) : (
            notifications.map((notification, index) => (
              <TableRow
                key={notification.id ?? index}
                className="hover:bg-gray-50 cursor-pointer"
                onClick={() => onRowClick?.(notification)}
              >
                <TableCell className={`text-gray-600 text-sm ${cellPadding}`}>
                  {notification.is_complete ? (
                    <Check
                      className="h-5 w-5 text-green-600"
                      aria-label="Complete"
                    />
                  ) : notification.status === "archived" ? (
                    "Archived"
                  ) : (
                    "Pending"
                  )}
                </TableCell>
                <TableCell
                  className={`text-gray-600 text-sm whitespace-nowrap ${cellPadding}`}
                >
                  {formatDateOnly(notification.start_date)}
                </TableCell>
                <TableCell
                  className={`text-gray-600 text-sm whitespace-nowrap ${cellPadding}`}
                >
                  {formatDateOnly(notification.end_date)}
                </TableCell>
                <TableCell
                  className={`text-gray-600 text-sm max-w-[240px] truncate ${cellPadding}`}
                  title={notification.audience_description ?? undefined}
                >
                  {notification.audience_description ?? "—"}
                </TableCell>
                <TableCell
                  className={`text-gray-600 text-sm whitespace-nowrap ${cellPadding}`}
                >
                  {formatDate(notification.created_at)}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default DeployNotificationsTable;
